export { default } from './MobilePrompt';
